// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCancelProviderServiceRequest: () => UseMutationResult<
  void,
  string,
  { providerServiceRequestCid: ContractId<ProviderServiceRequest> }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['cancelRegistryProviderServiceRequest', ledgerApi],
    mutationFn: async ({ providerServiceRequestCid }) => {
      return ledgerApi.cancelRegistryProviderServiceRequest(providerServiceRequestCid);
    },
  });
};

export default useCancelProviderServiceRequest;
